import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ReasonTranslation } from 'types';
import { Link, match } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FormikValues } from 'formik';
import Layout from 'components/templates/layout';
import { useIntl } from 'common/config/i18n';
import {
  reasonsSelectors,
  reasonActions,
  reasonSelectors,
  ClearStateSliceActions,
  TranslationLanguagesSelectors,
} from 'common/config/store';
import history from 'app-router/history';
import FormReason from 'components/templates/form-reason';
import Card from 'components/molecules/card';

const Wrapper = styled.div`
  margin: 5px;
`;
const StyledBreadcrumbWrapper = styled.div`
  margin: 10px 0 20px 20px;
`;
interface Props {
  match: match<Params>;
}
interface Params {
  id: string;
}
const ReasonPage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const { id } = props.match.params;

  const reasons = useSelector(reasonsSelectors.reasonsSelector);
  const status = useSelector(reasonSelectors.statusSelector);
  const error = useSelector(reasonSelectors.errorSelector);
  const translationLanguages = useSelector(TranslationLanguagesSelectors.translationLanguagesSelector);

  const reason = id ? reasons.find((reason) => reason.id.toString() === id) : undefined;

  useEffect(() => {
    return () => {
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Reason', sliceKey: 'error' }));
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Reason', sliceKey: 'status' }));
    };
  }, [dispatch]);

  const onSubmitHandler = (values: FormikValues) => {
    const { id, name, ...translations } = values;

    const formattedTranslations: Pick<ReasonTranslation, 'name' | 'languageCode'>[] = [];
    Object.keys(translations).forEach((code) => {
      return formattedTranslations.push({
        name: translations[code],
        languageCode: code,
      });
    });

    if (id) {
      dispatch(
        reasonActions.updateReason(
          {
            id,
            name,
            translations: formattedTranslations,
          },
          (result) => {
            if (!result.cancelled && !result.error) {
              history.push('/reasons');
            }
          }
        )
      );
    } else {
      dispatch(
        reasonActions.createReason(
          {
            name,
            translations: formattedTranslations,
          },
          (result) => {
            if (!result.cancelled && !result.error) {
              history.push('/reasons');
            }
          }
        )
      );
    }
  };

  const title = id ? t('ReasonPage', 'REASON_UPDATE') : t('ReasonPage', 'REASON_CREATE');

  return (
    <div>
      <Layout />
      <Wrapper>
        <StyledBreadcrumbWrapper>
          <Link to="/reasons">{t('ReasonPage', 'REASON_BACK')}</Link>
        </StyledBreadcrumbWrapper>

        <Card title={title}>
          <FormReason
            onSubmit={onSubmitHandler}
            reason={reason || undefined}
            translationLanguages={translationLanguages}
            error={error}
            status={status}
          />
        </Card>
      </Wrapper>
    </div>
  );
};

export default ReasonPage;
